export const MAX_TABLE_HEIGHT = 550;
export const ACTION_TABLE_COLUMN_WIDTH = '56px';
export const STATUS_PAGE_URL = 'https://status.commercetools.com/';
export const PROJECT_SETTINGS =
  'https://docs.commercetools.com/api/projects/project';

export default {
  MAX_TABLE_HEIGHT,
  ACTION_TABLE_COLUMN_WIDTH,
  STATUS_PAGE_URL,
  PROJECT_SETTINGS,
};
